import { render } from "./IconElectraPassengers.vue?vue&type=template&id=1ceb91b6"
import script from "./IconElectraPassengers.vue?vue&type=script&lang=js"
export * from "./IconElectraPassengers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__